/**
 * Journal d'audit : consultation filtrable, période bornée à 92 jours côté serveur.
 */
import { useState } from "react";

import { Chargement, Erreur, Vide } from "../../shared/composants/Etats";
import { formaterDate } from "../../shared/composants/formatage";
import { useAudit } from "./requetes";

export function EcranAudit() {
  const [entite, definirEntite] = useState("");
  const [acteur, definirActeur] = useState("");
  const requete = useAudit({ entite: entite || undefined, acteur: acteur || undefined });

  return (
    <section>
      <h1>Journal d'audit</h1>

      <div className="barre-de-filtres">
        <label htmlFor="filtre-entite">Entité</label>
        <input
          id="filtre-entite"
          placeholder="ex. SEUIL#batterie_faible_pct"
          value={entite}
          onChange={(e) => definirEntite(e.target.value)}
        />
        <label htmlFor="filtre-acteur">Acteur</label>
        <input
          id="filtre-acteur"
          placeholder="adresse email"
          value={acteur}
          onChange={(e) => definirActeur(e.target.value)}
        />
      </div>

      {requete.isPending && <Chargement libelle="Chargement du journal…" />}
      {requete.isError && <Erreur erreur={requete.error} reessayer={() => void requete.refetch()} />}
      {requete.data && requete.data.data.length === 0 && (
        <Vide libelle="Aucune entrée sur les sept derniers jours pour ces critères." />
      )}
      {requete.data && requete.data.data.length > 0 && (
        <ol className="frise">
          {requete.data.data.map((entree, index) => (
            <li key={`${entree.horodatage}-${index}`}>
              <strong>{entree.action}</strong>
              <span className="frise__date">{formaterDate(entree.horodatage)}</span>
              <p>
                {entree.entite} — {entree.acteur_email ?? entree.acteur_sub} ({entree.acteur_profil})
              </p>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
